const Order = ({ styles }) => {
  return (
    <div>
      <p
        style={{
          textAlign: "center",
          color: "#fcb71e",
          fontSize: 20,
          marginTop: 30,
        }}>
        <i className="fas fa-info-circle"></i> Đang nâng cấp
      </p>
      {/* <Table>
        <TableHead>
          <TableRow>
            <TableCell className={styles.tableCell}>Mã tin thu gom</TableCell>
            <TableCell className={styles.tableCell}>Mã bưu gửi</TableCell>
            <TableCell className={styles.tableCell}>
              Trạng thái đơn hàng
            </TableCell>
            <TableCell className={styles.tableCell}>
              Thời gian cập nhật
            </TableCell>

            <TableCell className={styles.tableCell}>Xem</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={styles.tableCell}>123</TableCell>
            <TableCell className={styles.tableCell}>CZ982916294VN</TableCell>
            <TableCell className={styles.tableCell}>
              Phát không thành công
            </TableCell>
            <TableCell className={styles.tableCell}>16/01/2021 10:36</TableCell>
            <TableCell>
              <div>
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  onClick={() => {}}
                >
                  <Visibility />
                </Fab>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={styles.tableCell}>456</TableCell>
            <TableCell className={styles.tableCell}>CZ982916295VN</TableCell>
            <TableCell className={styles.tableCell}>Đã đến bưu cục</TableCell>
            <TableCell className={styles.tableCell}>16/01/2021 10:36</TableCell>
            <TableCell>
              <div>
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  onClick={() => {}}
                >
                  <Visibility />
                </Fab>
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table> */}
    </div>
  );
};

export default Order;
